import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';

interface AditoolsCardTooltipArgs {
  Element: HTMLButtonElement;
  Args: {
    icon: string;
    qaName?: string;
    tooltip?: string;
    clicked?: (event: MouseEvent) => void;
  };
  Blocks: {
    default: [() => void];
  };
}

export default class AditoolsCardTooltip extends Component<AditoolsCardTooltipArgs> {
  @service declare intl: IntlService;

  @tracked tooltipEnabled = false;

  get qaName() {
    return this.args.qaName ?? 'unnamed';
  }

  get _tooltip() {
    return this.args.tooltip ?? this.intl.t('ember-aditools-page.card.help-tooltip');
  }

  @action headerTooltipClicked(event: MouseEvent) {
    this.tooltipEnabled = true;
    if (this.args.clicked) {
      this.args.clicked(event);
    }
  }
  @action tooltipClosed() {
    this.tooltipEnabled = false;
  }
}
